import { render, staticRenderFns } from "./UserDetail_Canceled_SessionTutor.vue?vue&type=template&id=5952a886&"
import script from "./UserDetail_Canceled_SessionTutor.vue?vue&type=script&lang=js&"
export * from "./UserDetail_Canceled_SessionTutor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports